import { getFenceTerminal,getElectronicFence,insertElectronicFence,updateElectronicFence,deleteElectronicFence,getFenceCarMessage,getChoiceTerminal } from "../../api/config/modules/ElectricFence";

const state = {
  getFenceTerminal: {},
  getElectronicFence: {},
  insertElectronicFence: {},
  updateElectronicFence: {},
  deleteElectronicFence: {},
  getFenceCarMessage: {},
  getChoiceTerminal: {}
};

const mutations = {
  SET_GETFENCETERMINAL: (state, getFenceTerminal) => {
    state.getFenceTerminal = getFenceTerminal;
  },
  SET_GETELECTRONICFENCE: (state, getElectronicFence) => {
    state.getElectronicFence = getElectronicFence;
  },
  SET_INSERTELECTRONICFENCE: (state, insertElectronicFence) => {
    state.insertElectronicFence = insertElectronicFence;
  },
  SET_UPDATEELECTRONICFENCE: (state, updateElectronicFence) => {
    state.updateElectronicFence = updateElectronicFence;
  },
  SET_DELETEELECTRONICFENCE: (state, deleteElectronicFence) => {
    state.deleteElectronicFence = deleteElectronicFence;
  },
  SET_GETFENCECARMESSAGE: (state, getFenceCarMessage) => {
    state.getFenceCarMessage = getFenceCarMessage;
  },
  SET_GETCHOICETERMINAL: (state, getChoiceTerminal) => {
    state.getChoiceTerminal = getChoiceTerminal;
  },
};

const actions = {
  GET_GETFENCETERMINAL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getFenceTerminal(data)
        .then((res) => {
          commit("SET_GETFENCETERMINAL", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETELECTRONICFENCE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getElectronicFence(data)
        .then((res) => {
          commit("SET_GETELECTRONICFENCE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTELECTRONICFENCE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      insertElectronicFence(data)
        .then((res) => {
          commit("SET_INSERTELECTRONICFENCE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEELECTRONICFENCE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      updateElectronicFence(data)
        .then((res) => {
          commit("SET_UPDATEELECTRONICFENCE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEELECTRONICFENCE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      deleteElectronicFence(data)
        .then((res) => {
          commit("SET_DELETEELECTRONICFENCE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETFENCECARMESSAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getFenceCarMessage(data)
        .then((res) => {
          commit("SET_GETFENCECARMESSAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCHOICETERMINAL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getChoiceTerminal(data)
        .then((res) => {
          commit("SET_GETCHOICETERMINAL", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
